'use client';

import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { Toaster } from 'sonner';

export function AppToaster() {
  const { resolvedTheme } = useTheme();
  // Guard against SSR/first-hydration theme flip (matches Sidebar's pattern);
  // avoids depending on sonner internals for hydration safety.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <Toaster
      position="top-right"
      theme={mounted && resolvedTheme === 'light' ? 'light' : 'dark'}
      richColors
      closeButton
    />
  );
}
